export const TripTypesList = [
    'Empty In',
    'Empty Out',
    'Full In',
    'Full Out',
    'Chassis In',
    'Chassis Out',
    'Street Turn',
    'Drop Load',
    'Pick Load',
    'Live Load',
    'Live Unload',
    'Off Hire',
    'Drop Empty',
    'Pick Empty',
  ];